<ng-template #template>
  <svc-action-button [text]="model.linkValueText" [click]="model.doLinkClick.bind(model)" [selected]="model.isSelected"
    [disabled]="!model.isClickable" [classes]="model.linkSetButtonCssClasses" [title]="model.tooltip" [iconName]="model.iconName">
  </svc-action-button>
  <ng-container *ngIf="!model.isReadOnly && model.showClear">
    <svc-action-button [text]="clearCaption" [click]="model.doClearClick.bind(model)"
      [disabled]="false" [classes]="model.linkClearButtonCssClasses">
    </svc-action-button>
  </ng-container>
</ng-template>